(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minimal-cart-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
    const content = drawer.querySelector('[data-cart-content]');
    const recommendations = JSON.parse(drawer.querySelector('[data-cart-recommendations]')?.textContent || '[]');
    const root = window.Shopify?.routes?.root || '/';
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      currency: currency || 'USD',
      currencyDisplay: 'symbol',
      style: 'currency'
    }).format(amount / 100);
    const decodeHtml = (value) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = String(value || '');
      return textarea.value;
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
    })[character]);
    const shippingGoal = Math.max(0, Number(drawer.dataset.freeShippingGoal || 0)) * 100;
    let latestCart;
    let lastTrigger;
    let recommendationsCollapsed = false;
    let cartBusy = false;
    let cartLoadFailed = false;
    let refreshPromise;
    let refreshQueued = false;
    const status = drawer.querySelector('[data-cart-status]');
    let sizeModule;
    const loadSizeModule = () => sizeModule || (sizeModule = import(drawer.dataset.sizeModule).catch((error) => { sizeModule = null; throw error; }));
    const products = new Map();
    const editableSize = (item) => !item.selling_plan_allocation && !item.parent_relationship && !item.item_components?.length
      && (item.options_with_values || []).some((option) => ['size', 'sizes', 'размер', 'розмір', 'talla', 'taille', 'größe', 'taglia', 'tamanho', 'サイズ'].includes(String(option.name).trim().toLowerCase()));
    const setBusy = (busy) => {
      cartBusy = busy;
      drawer.setAttribute('aria-busy', String(busy));
      content.querySelectorAll('button:not([data-cart-close]), select').forEach((control) => { control.disabled = busy || control.dataset.sizeUnavailable === 'true' || (cartLoadFailed && !control.matches('[data-cart-retry]')); });
      const checkout = content.querySelector('.minimal-cart-drawer__checkout');
      if (checkout) {
        checkout.setAttribute('aria-disabled', String(busy || cartLoadFailed));
        checkout.tabIndex = busy || cartLoadFailed ? -1 : 0;
      }
    };

    const recommendationMarkup = (cart) => {
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const available = recommendations.filter((product) => product.available && !cartProductIds.has(product.id)).slice(0, 5);
      if (!available.length) return '';

      return `
        <section class="minimal-cart-drawer__recommendations${recommendationsCollapsed ? ' is-collapsed' : ''}">
          <button class="minimal-cart-drawer__recommendations-title" type="button" data-recommendations-toggle aria-expanded="${String(!recommendationsCollapsed)}">${escapeHtml(drawer.dataset.recommendationsLabel)}</button>
          <div class="minimal-cart-drawer__recommendations-grid">
            ${available.map((product) => `
              <article>
                <a class="minimal-cart-drawer__recommendation-image" href="${escapeHtml(product.url)}">
                  ${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
                </a>
                <a class="minimal-cart-drawer__recommendation-title" href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a>
                <span class="minimal-cart-drawer__recommendation-price">${money(product.price, cart.currency)}</span>
                ${product.hasSingleVariant && !product.isPreorder ? `<button class="minimal-cart-drawer__recommendation-action" type="button" data-recommendation-add="${product.variantId}">${escapeHtml(drawer.dataset.addLabel)}</button>` : `<a class="minimal-cart-drawer__recommendation-action" href="${escapeHtml(product.url)}">${escapeHtml(drawer.dataset.viewLabel)}</a>`}
              </article>
            `).join('')}
          </div>
        </section>
      `;
    };

    const itemMarkup = (item, cart) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="minimal-cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && typeof value === 'string' && value)
        .map(([key, value]) => `<p class="minimal-cart-drawer__item-variant">${escapeHtml(key)}: ${escapeHtml(value)}</p>`).join('');
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const removeLabel = drawer.dataset.removeLabel.replace('__product__', item.product_title);
      return `
        <article class="minimal-cart-drawer__item" data-cart-line="${escapeHtml(item.key)}">
          <a class="minimal-cart-drawer__image" href="${escapeHtml(item.url)}">${image}</a>
          <div>
            <a class="minimal-cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
            ${variant}
            ${editableSize(item) ? `<button type="button" class="minimal-cart-drawer__size-edit" data-cart-edit-size="${escapeHtml(item.key)}" aria-expanded="false">${escapeHtml(drawer.dataset.sizeEdit)}</button><div data-cart-size-editor></div>` : ''}
            ${properties}
            <p class="minimal-cart-drawer__item-price">${money(item.final_line_price, cart.currency)}</p>
          </div>
          <div class="minimal-cart-drawer__quantity">
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHtml(drawer.dataset.decreaseLabel)}">−</button>
            <span>${item.quantity}</span>
            <button class="minimal-cart-drawer__quantity-button" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(drawer.dataset.increaseLabel)}">+</button>
            <button class="minimal-cart-drawer__remove" type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="0" aria-label="${escapeHtml(removeLabel)}">×</button>
          </div>
        </article>
      `;
    };

    const render = (cart) => {
      latestCart = cart;
      cartLoadFailed = false;
      if (!cart.item_count) {
        content.innerHTML = `<div class="minimal-cart-drawer__state"><p class="minimal-cart-drawer__empty">${escapeHtml(drawer.dataset.emptyLabel)}</p><a class="minimal-cart-drawer__continue" href="${escapeHtml(root)}?catalog=1">${escapeHtml(drawer.dataset.continueLabel)}</a></div>`;
        return;
      }

      const remaining = Math.max(0, shippingGoal - cart.total_price);
      const progress = shippingGoal ? Math.min(100, (cart.total_price / shippingGoal) * 100) : 0;
      const shipping = shippingGoal ? (remaining ? decodeHtml(drawer.dataset.awayLabel).replace('__amount__', money(remaining, cart.currency)) : decodeHtml(drawer.dataset.freeShippingLabel)) : '';
      content.innerHTML = `
        ${shippingGoal ? `<p class="minimal-cart-drawer__shipping">${escapeHtml(shipping)}</p><div class="minimal-cart-drawer__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span class="minimal-cart-drawer__progress-fill" style="width:${progress}%"></span></div>` : ''}
        <div class="minimal-cart-drawer__items">${cart.items.map((item) => itemMarkup(item, cart)).join('')}</div>
        <div class="minimal-cart-drawer__footer">
          <span class="minimal-cart-drawer__total-label">${escapeHtml(drawer.dataset.totalLabel)}</span>
          <span class="minimal-cart-drawer__total-price">${money(cart.total_price, cart.currency)}</span>
          <a class="minimal-cart-drawer__checkout" href="${root}checkout">${escapeHtml(drawer.dataset.checkoutLabel)}</a>
          <button class="minimal-cart-drawer__keep-shopping" type="button" data-cart-close>${escapeHtml(drawer.dataset.continueLabel)}</button>
        </div>
        ${recommendationMarkup(cart)}
      `;
    };

    const getCart = async () => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${root}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0 || !Array.isArray(cart.items) || (cart.item_count === 0) !== (cart.items.length === 0) || !Number.isFinite(cart.total_price) || cart.total_price < 0) throw new Error('Invalid cart response');
        render(cart);
        return cart;
      } finally { window.clearTimeout(timeout); }
    };

    const refreshCart = (restoreFocus = false) => {
      if (refreshPromise) return refreshPromise;
      if (cartBusy) return Promise.resolve();
      content.querySelector('[data-cart-load-error]')?.remove();
      if (!latestCart) content.innerHTML = `<div class="minimal-cart-drawer__state"><p class="minimal-cart-drawer__state-copy" role="status">${escapeHtml(drawer.dataset.loadingLabel)}</p></div>`;
      status.textContent = latestCart ? drawer.dataset.loadingLabel : '';
      setBusy(true);
      refreshPromise = getCart().then(() => {
        status.textContent = '';
      }).catch(() => {
        cartLoadFailed = true;
        const message = latestCart ? drawer.dataset.loadCached : drawer.dataset.loadError;
        const markup = `<div class="minimal-cart-drawer__state${latestCart ? ' minimal-cart-drawer__state--cached' : ''}" data-cart-load-error><h2 class="minimal-cart-drawer__state-title">${escapeHtml(drawer.dataset.loadErrorHeading)}</h2><p class="minimal-cart-drawer__state-copy" role="alert">${escapeHtml(message)}</p><div class="minimal-cart-drawer__state-actions"><button class="minimal-cart-drawer__state-action minimal-cart-drawer__state-action--primary" type="button" data-cart-retry>${escapeHtml(drawer.dataset.retryLabel)}</button><a class="minimal-cart-drawer__state-action" href="${escapeHtml(root)}cart">${escapeHtml(drawer.dataset.pageLabel)}</a></div></div>`;
        if (latestCart) content.insertAdjacentHTML('afterbegin', markup);
        else content.innerHTML = markup;
        status.textContent = '';
      }).finally(() => {
        refreshPromise = null;
        setBusy(false);
        if (restoreFocus && !drawer.hidden && !drawer.inert) content.querySelector('[data-cart-retry], .minimal-cart-drawer__item-title, .minimal-cart-drawer__continue')?.focus({ preventScroll: true });
        if (refreshQueued) {
          refreshQueued = false;
          if (!drawer.hidden && !drawer.inert) refreshCart();
        }
      });
      return refreshPromise;
    };

    let closeTimer;
    let openFrame;
    let savedOverflow = '';

    const close = () => {
      if (drawer.hidden || drawer.inert) return;
      window.clearTimeout(closeTimer);
      window.cancelAnimationFrame(openFrame);
      drawer.classList.remove('is-open');
      drawer.inert = true;
      drawer.setAttribute('aria-hidden', 'true');
      const finish = () => {
        drawer.hidden = true;
        document.documentElement.style.overflow = savedOverflow;
        const trigger = lastTrigger?.isConnected && !lastTrigger.disabled ? lastTrigger : document.querySelector('[data-cart-trigger]');
        trigger?.focus({ preventScroll: true });
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else {
        const duration = parseFloat(getComputedStyle(drawer).getPropertyValue('--minimal-motion-panel')) || 260;
        closeTimer = window.setTimeout(finish, duration);
      }
    };

    const open = async (trigger) => {
      if (!drawer.hidden && !drawer.inert) {
        if (refreshPromise) refreshQueued = true;
        else if (!cartBusy) await refreshCart();
        return;
      }
      window.clearTimeout(closeTimer);
      window.cancelAnimationFrame(openFrame);
      if (drawer.hidden) savedOverflow = document.documentElement.style.overflow;
      lastTrigger = trigger || document.activeElement;
      drawer.hidden = false;
      drawer.inert = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      void drawer.offsetWidth;
      openFrame = window.requestAnimationFrame(() => drawer.classList.add('is-open'));
      drawer.querySelector('.minimal-cart-drawer__close')?.focus({ preventScroll: true });
      await refreshCart();
    };

    drawer.querySelectorAll('[data-cart-close]').forEach((control) => control.addEventListener('click', close));
    document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => trigger.addEventListener('click', (event) => { event.preventDefault(); open(trigger); }));
    window.addEventListener('minimal:cart-open', () => open());
    window.addEventListener('minimal:cart-updated', (event) => {
      if (event.detail?.added && drawer.dataset.openAfterAdding === 'true') {
        open(event.detail.trigger);
        return;
      }
      if (drawer.hidden || drawer.inert) return;
      if (refreshPromise) refreshQueued = true;
      else if (!cartBusy) refreshCart();
    });
    document.addEventListener('keydown', (event) => {
      if (drawer.hidden || drawer.inert) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const panel = drawer.querySelector('.minimal-cart-drawer__panel');
      const controls = [...panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
        .filter((control) => !control.disabled && control.tabIndex >= 0 && !control.closest('[inert]') && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      const outside = !panel.contains(document.activeElement);
      if (first && (outside || (event.shiftKey ? document.activeElement === first : document.activeElement === last))) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      }
    });

    content.addEventListener('click', async (event) => {
      if (event.target.closest('[data-cart-close]')) {
        event.preventDefault();
        close();
        return;
      }
      if (cartBusy) { event.preventDefault(); return; }
      if (event.target.closest('[data-cart-retry]')) {
        event.preventDefault();
        await refreshCart(true);
        return;
      }
      if (cartLoadFailed && event.target.closest('.minimal-cart-drawer__checkout')) { event.preventDefault(); return; }
      const editSize = event.target.closest('[data-cart-edit-size]');
      const sizeChoice = event.target.closest('[data-cart-size-value]');
      if (editSize) {
        const item = latestCart?.items.find((line) => line.key === editSize.dataset.cartEditSize);
        if (!item) return;
        const panel = editSize.parentElement.querySelector('[data-cart-size-editor]');
        if (editSize.getAttribute('aria-expanded') === 'true') {
          panel.replaceChildren();
          editSize.setAttribute('aria-expanded', 'false');
          return;
        }
        status.textContent = drawer.dataset.sizeLoading;
        setBusy(true);
        try {
          const module = await loadSizeModule();
          const handle = item.handle || new URL(item.url, location.origin).pathname.split('/products/')[1]?.split('/')[0];
          if (!handle) throw new Error('Missing product');
          if (!products.has(handle)) {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Unable to load sizes');
            products.set(handle, await response.json());
          }
          const variants = module.sizeVariants(item, products.get(handle));
          if (!variants.length) throw new Error('No sizes found');
          panel.innerHTML = `<div class="minimal-cart-drawer__size-options" role="group" aria-label="${escapeHtml(drawer.dataset.sizeLabel)}">${variants.map((variant) => `<button class="minimal-cart-drawer__size-option" type="button" data-cart-size-value="${variant.id}" data-size-unavailable="${String(!variant.available)}" aria-pressed="${String(Number(variant.id) === Number(item.variant_id))}" aria-label="${escapeHtml(drawer.dataset.sizeLabel)}: ${escapeHtml(variant.label)}${variant.available ? '' : ` — ${escapeHtml(drawer.dataset.sizeUnavailable)}`}"${variant.available ? '' : ' disabled'}>${escapeHtml(variant.label)}</button>`).join('')}</div>`;
          editSize.setAttribute('aria-expanded', 'true');
          status.textContent = '';
        } catch { status.textContent = drawer.dataset.sizeError; }
        finally {
          setBusy(false);
          if (!drawer.hidden && !drawer.inert) (panel.querySelector('[aria-pressed="true"]:not(:disabled)') || panel.querySelector('button:not(:disabled)') || editSize).focus({ preventScroll: true });
        }
        return;
      }
      if (sizeChoice) {
        const item = latestCart?.items.find((line) => line.key === sizeChoice.closest('[data-cart-line]')?.dataset.cartLine);
        const variantId = Number(sizeChoice.dataset.cartSizeValue);
        if (!item || !variantId || sizeChoice.dataset.sizeUnavailable === 'true' || Number(item.variant_id) === variantId) return;
        let focusTarget = sizeChoice;
        setBusy(true);
        status.textContent = drawer.dataset.sizeSaving;
        try {
          const module = await loadSizeModule();
          const updated = await module.replaceSize({ root, item, variantId });
          render(updated);
          status.textContent = '';
          const replacement = updated.items.find((line) => Number(line.variant_id) === variantId);
          focusTarget = [...content.querySelectorAll('[data-cart-line]')].find((article) => article.dataset.cartLine === replacement?.key)?.querySelector('[data-cart-edit-size]');
        } catch (error) {
          try { await getCart(); } catch {}
          status.textContent = error.partial ? drawer.dataset.sizePartial : drawer.dataset.sizeError;
          if (!focusTarget?.isConnected) focusTarget = [...content.querySelectorAll('[data-cart-line]')].find((article) => article.dataset.cartLine === item.key)?.querySelector('[data-cart-edit-size]');
        } finally {
          window.dispatchEvent(new Event('minimal:cart-updated'));
          setBusy(false);
          if (!drawer.hidden && !drawer.inert) (focusTarget || drawer.querySelector('.minimal-cart-drawer__close')).focus({ preventScroll: true });
        }
        return;
      }
      const recommendationsToggle = event.target.closest('[data-recommendations-toggle]');
      if (recommendationsToggle) {
        const section = recommendationsToggle.closest('.minimal-cart-drawer__recommendations');
        recommendationsCollapsed = section.classList.toggle('is-collapsed');
        recommendationsToggle.setAttribute('aria-expanded', String(!recommendationsCollapsed));
        return;
      }

      const change = event.target.closest('[data-cart-change]');
      const add = event.target.closest('[data-recommendation-add]');
      if (!change && !add) return;
      event.preventDefault();
      setBusy(true);
      status.textContent = '';
      try {
        if (change) {
          const response = await fetch(`${root}cart/change.js`, {
            body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
          if (!response.ok) throw new Error('Unable to update cart');
        }
        if (add) {
          const response = await fetch(`${root}cart/add.js`, {
            body: JSON.stringify({ id: Number(add.dataset.recommendationAdd), quantity: 1 }),
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
          if (!response.ok) throw new Error('Unable to add item');
        }
        await getCart();
        window.dispatchEvent(new Event('minimal:cart-updated'));
      } catch (error) {
        if (latestCart) render(latestCart);
        status.textContent = drawer.dataset.updateError;
      } finally {
        setBusy(false);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["minimal-cookie-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-cookie-banner]').forEach((banner) => {
    const manageButton = banner.querySelector('[data-cookie-manage]');
    const acceptButton = banner.querySelector('[data-cookie-accept]');
    const declineButton = banner.querySelector('[data-cookie-decline]');
    const saveButton = banner.querySelector('[data-cookie-save]');
    const preferences = banner.querySelector('[data-cookie-preferences]');
    const preferenceInput = banner.querySelector('[data-cookie-preferences-input]');
    const analyticsInput = banner.querySelector('[data-cookie-analytics-input]');
    const marketingInput = banner.querySelector('[data-cookie-marketing-input]');
    const responseStorageKey = 'minimal-cookie-banner-response-v1';

    const announceState = () => {
      document.dispatchEvent(new CustomEvent('minimal:cookie-banner-state', {
        detail: { visible: !banner.hidden }
      }));
    };
    const hideBanner = () => {
      banner.hidden = true;
      announceState();
    };
    const hasAnswer = (value) => value === 'yes' || value === 'no';

    const hasLocalResponse = () => {
      try {
        return window.localStorage.getItem(responseStorageKey) === 'saved';
      } catch (error) {
        return false;
      }
    };

    const rememberResponse = () => {
      try {
        window.localStorage.setItem(responseStorageKey, 'saved');
      } catch (error) {
        return;
      }
    };

    const captureConsent = (consent) => {
      const privacy = window.Shopify?.customerPrivacy;
      /* Store only that the visitor answered. Shopify remains the source of
         truth for the consent choices; this prevents a visual banner loop if
         its API initialises again during storefront navigation. */
      rememberResponse();
      hideBanner();
      privacy?.setTrackingConsent?.(consent, hideBanner);
    };

    const showWhenNeeded = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return;

      const visitorConsent = privacy.currentVisitorConsent?.() || {};
      const hasRecordedChoice = [visitorConsent.preferences, visitorConsent.analytics, visitorConsent.marketing].some(hasAnswer);
      const requiredByRegion = privacy.shouldShowBanner?.() === true;

      banner.hidden = hasLocalResponse() || !(requiredByRegion || !hasRecordedChoice);
      announceState();
    };

    const initialisePrivacyApi = () => {
      if (window.Shopify?.customerPrivacy) {
        showWhenNeeded();
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        announceState();
        return;
      }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) {
          showWhenNeeded();
        } else {
          announceState();
        }
      });
    };

    manageButton?.addEventListener('click', () => {
      const current = window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || {};
      preferenceInput.checked = current.preferences === 'yes';
      analyticsInput.checked = current.analytics === 'yes';
      marketingInput.checked = current.marketing === 'yes';
      preferences.hidden = false;
      manageButton.hidden = true;
    });

    acceptButton?.addEventListener('click', () => captureConsent({ preferences: true, analytics: true, marketing: true }));
    declineButton?.addEventListener('click', () => captureConsent({ preferences: false, analytics: false, marketing: false }));
    saveButton?.addEventListener('click', () => captureConsent({
      preferences: preferenceInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));

    initialisePrivacyApi();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v3-language-selector')) {
    customElements.define('v3-language-selector', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        const form = this.querySelector('form');
        const select = this.querySelector('select');
        const submit = this.querySelector('button[type="submit"]');
        if (!form || !select || !submit || typeof form.requestSubmit !== 'function') return;
        this.controller = new AbortController();
        select.addEventListener('change', () => {
          const returnTo = form.querySelector('input[name="return_to"]');
          if (returnTo) returnTo.value = window.location.pathname + window.location.search;
          form.requestSubmit();
        }, { signal: this.controller.signal });
        submit.hidden = true;
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-main-products"] && !Shopify.designMode) return;
  try {
    (() => {
  const minimalCatalogLayoutStorageKey = document.querySelector('.product-carousel')?.dataset.layoutStorageKey || 'minimal-collections-catalog-layout-v2-single';

  let isOpeningProductPage = false;

  /* Mobile Safari restores the home page from its back-forward cache instead
     of re-running this script. Reset the one-shot product-navigation guard so
     a card remains tappable after the visitor uses the browser back button. */
  window.addEventListener('pageshow', () => {
    isOpeningProductPage = false;
    document.documentElement.classList.remove('minimal-product-page-leaving');
  });

  const openProductPageFromCard = (url) => {
    if (!url) return false;
    if (isOpeningProductPage) return true;

    window.minimalRememberCatalog?.(url);
    isOpeningProductPage = true;
    try {
      window.sessionStorage.setItem('minimal-product-page-enter', '1');
    } catch (error) {
      // Navigation still works when browser storage is unavailable.
    }

    document.documentElement.classList.add('minimal-product-page-leaving');
    window.setTimeout(() => window.location.assign(url), 220);
    return true;
  };

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest?.('a[data-product-page-link]');
    if (!productLink?.href || event.defaultPrevented) return;
    // Gallery clicks must reach its drag guard before opening the product.
    if (productLink.closest('[data-media-track]')) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    openProductPageFromCard(productLink.href);
  }, true);

  const readMinimalCatalogLayout = () => {
    try {
      return JSON.parse(window.localStorage.getItem(minimalCatalogLayoutStorageKey) || '{}');
    } catch (error) {
      return {};
    }
  };
  const writeMinimalCatalogLayout = (breakpoint, layout) => {
    const savedLayout = readMinimalCatalogLayout();
    savedLayout[breakpoint] = layout;
    try {
      window.localStorage.setItem(minimalCatalogLayoutStorageKey, JSON.stringify(savedLayout));
    } catch (error) {
      return;
    }
  };
  /* Header settings can re-render independently in the theme editor. Keep the
     latest state so a newly rendered Glass or Classic header can restore its
     grid control without waiting for the carousel to initialise again. */
  const publishMinimalCatalogLayoutState = (detail) => {
    window.minimalCatalogLayoutState = detail;
    window.dispatchEvent(new CustomEvent('minimal-layout-state', { detail }));
  };

  const catalogCleanups = new Map();
  const galleryCleanups = new Map();
  const initializeV3ProductRow = (carousel, track, signal) => {
    const controls = carousel.querySelector('[data-v3-row-controls]');
    const previous = carousel.querySelector('[data-v3-row-previous]');
    const next = carousel.querySelector('[data-v3-row-next]');
    let frame = 0;
    let pointer = null;
    let dragged = false;
    let suppressClick = false;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    const step = () => {
      const cards = track.querySelectorAll('[data-v3-grid-card]');
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    };
    const sync = () => {
      frame = 0;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      if (controls) controls.hidden = maximum < 2;
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maximum - 2;
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const move = (direction) => track.scrollTo({ left: track.scrollLeft + step() * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    previous?.addEventListener('click', () => move(-1), { signal });
    next?.addEventListener('click', () => move(1), { signal });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'instant' });
      else move(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    track.addEventListener('scroll', queue, { passive: true, signal });
    window.addEventListener('resize', queue, { passive: true, signal });
    carousel.addEventListener('minimal:catalog-appended', queue, { signal });
    track.addEventListener('pointerdown', (event) => {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, textarea')) return;
      pointer = event.pointerId;
      dragged = false;
      startX = event.clientX;
      startY = event.clientY;
      startScroll = track.scrollLeft;
    }, { signal });
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointer) return;
      const distance = event.clientX - startX;
      if (!dragged && Math.abs(distance) > 8 && Math.abs(distance) > Math.abs(event.clientY - startY)) {
        dragged = true;
        suppressClick = true;
        track.style.scrollSnapType = 'none';
        track.setPointerCapture?.(pointer);
        carousel.classList.add('is-row-dragging');
      }
      if (!dragged) return;
      event.preventDefault();
      track.scrollLeft = startScroll - distance;
    }, { signal });
    const release = (event) => {
      if (event.pointerId !== pointer) return;
      if (track.hasPointerCapture?.(pointer)) track.releasePointerCapture(pointer);
      pointer = null;
      carousel.classList.remove('is-row-dragging');
      track.style.removeProperty('scroll-snap-type');
      if (dragged) track.scrollTo({ left: Math.round(track.scrollLeft / Math.max(1, step())) * step(), behavior: 'instant' });
      dragged = false;
      queue();
    };
    window.addEventListener('pointerup', release, { signal });
    window.addEventListener('pointercancel', release, { signal });
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, { capture: true, signal });
    const observer = new ResizeObserver(queue);
    observer.observe(track);
    sync();
    return () => { observer.disconnect(); cancelAnimationFrame(frame); track.style.removeProperty('scroll-snap-type'); carousel.classList.remove('is-row-dragging'); };
  };
  const initializeCatalog = (root) => {
  root.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
    if (catalogCleanups.has(carousel)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    let revealObserver;
    let wasMobile = window.innerWidth < 750;
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const track = carousel.querySelector('[data-carousel-track]');
    if (!viewport || !track) return;
    const pageScroller = carousel.closest('#MainContent');
    const productSlides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const pagination = carousel.querySelector('minimal-catalog-pagination');
    const catalogOffset = Number(pagination?.dataset.offset) || 0;
    const catalogTotal = Number(pagination?.dataset.total) || productSlides.length;
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    const configuredColumns = Math.max(1, Number(carousel.dataset.productsPerRow) || 1);
    const configuredGridColumns = Math.min(6, Math.max(2, Number(carousel.dataset.gridColumns) || 3));
    const configuredMobileGridColumns = Math.min(2, Math.max(1, Number(carousel.style.getPropertyValue('--product-carousel-mobile-columns')) || 2));
    const initialCatalogLayout = carousel.dataset.initialLayout === 'grid' ? 'grid' : 'single';
    const singleTransition = carousel.dataset.singleTransition || 'vertical';
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    const hasCampaign = () => Boolean(document.querySelector('.minimal-campaign:not(.is-dismissed)'));
    /* The header grid switch should feel like a catalogue on desktop, while
       mobile keeps its intentionally compact two-card layout. */
    const gridColumns = configuredColumns > 1 ? configuredColumns : Math.min(configuredGridColumns, catalogTotal);
    const hasMultipleProducts = catalogTotal > 1;
    const canUseDesktopGrid = hasMultipleProducts && gridColumns > 1;
    const canUseMobileGrid = hasMultipleProducts;
    let activeIndex = 0;
    let gridFocusIndex = 0;
    let isTransitioning = false;
    let isSingleLayout = configuredColumns === 1;
    let startX = 0;
    let startY = 0;
    let swipeOffset = 0;
    let mobileDragFrame = 0;
    let footerOpen = false;
    let footerUnlockAt = 0;
    let stageResumeLockedUntil = 0;
    let stageTransitionTimer;
    let wheelGestureActive = false;
    let wheelGestureDirection = 0;
    let wheelGestureReleaseTimer;
    let desktopLastStageReady = productSlides.length === 1;
    let desktopLastStageUnlockTimer;
    let mobileGridActive = false;
    let stageTouchEnabled = false;
    const stageMediaPrevious = carousel.querySelector('[data-stage-media-previous]');
    const stageMediaNext = carousel.querySelector('[data-stage-media-next]');
    const productCounterCurrent = carousel.querySelector('[data-product-counter-current]');
    const productCounterTotal = carousel.querySelector('[data-product-counter-total]');
    const swipeHint = carousel.querySelector('[data-carousel-swipe-hint]');

    const isMobileGrid = () => mobileGridActive && window.innerWidth < 750;
    const usesHorizontalCarousel = () => !isMobileGrid() && isSingleLayout && singleTransition === 'horizontal' && window.innerWidth >= 750;
    const usesVerticalCarousel = () => !isMobileGrid() && !usesHorizontalCarousel() && (isSingleLayout || window.innerWidth < 750);
    const usesStageCarousel = () => usesHorizontalCarousel() || usesVerticalCarousel();
    /* The original product feed used the browser's native scroll physics.
       Keep that behaviour on mobile too: it handles quick reversals and
       momentum far more reliably than translating the track in JavaScript. */
    const usesNativeStage = () => !footerOpen && usesVerticalCarousel();
    const isLastStageProduct = () => !mobileGridActive && catalogOffset + activeIndex === catalogTotal - 1;
    const isMobileLastProduct = () => window.innerWidth < 750 && isLastStageProduct();
    const armDesktopLastStageHandoff = () => {
      if (window.innerWidth < 750 || !isLastStageProduct()) return;

      window.clearTimeout(desktopLastStageUnlockTimer);
      desktopLastStageUnlockTimer = window.setTimeout(() => {
        if (!isLastStageProduct() || isTransitioning) return;
        desktopLastStageReady = true;
        syncLastStageProduct();
      }, 160);
    };
    const syncLastStageProduct = () => {
      const isLastProduct = isLastStageProduct();

      if (isLastProduct) {
        if (window.innerWidth >= 750 && desktopLastStageReady) {
          pageScroller?.style.setProperty('overflow-y', 'auto');
          pageScroller?.style.setProperty('scroll-behavior', 'auto');
        } else {
          pageScroller?.style.removeProperty('overflow-y');
          pageScroller?.style.removeProperty('scroll-behavior');
        }
        if (window.innerWidth < 750) viewport.style.setProperty('touch-action', 'auto');
        return;
      }

      desktopLastStageReady = false;
      window.clearTimeout(desktopLastStageUnlockTimer);
      pageScroller?.style.removeProperty('overflow-y');
      pageScroller?.style.removeProperty('scroll-behavior');
      viewport.style.removeProperty('touch-action');
    };

    const syncStageMediaArrows = () => {
      const media = productSlides[activeIndex]?.querySelector('[data-product-media-carousel]');
      const show = usesVerticalCarousel() && (media?.querySelectorAll('[data-media-slide]').length || 0) > 1;
      [stageMediaPrevious, stageMediaNext].forEach((control) => {
        if (control) control.hidden = !show;
      });
    };

    const syncProductCounter = () => {
      if (productCounterCurrent) productCounterCurrent.textContent = String(catalogOffset + activeIndex + 1).padStart(2, '0');
      if (productCounterTotal) productCounterTotal.textContent = String(catalogTotal).padStart(2, '0');
      carousel.dataset.catalogActiveIndex = String(activeIndex);
      carousel.dataset.catalogStage = String(usesStageCarousel());
      carousel.dispatchEvent(new Event('minimal:catalog-progress'));
    };

    const syncSwipeHint = () => {
      if (!swipeHint) return;
      carousel.classList.toggle('product-carousel--swipe-hint-visible', activeIndex === 0 && productSlides.length > 1 && usesStageCarousel());
    };

    const notifyLayoutState = () => {
      const isMobile = window.innerWidth < 750;
      publishMinimalCatalogLayoutState({
        available: isMobile ? canUseMobileGrid : canUseDesktopGrid,
        single: isMobile ? !mobileGridActive : isSingleLayout
      });
      syncProductCounter();
    };

    const getNativeStageScrollTop = (index) => {
      const slide = productSlides[index];
      if (!slide) return 0;

      return Math.max(0, slide.offsetTop - Math.max(0, (viewport.clientHeight - slide.offsetHeight) / 2));
    };

    const updateTrackPosition = (offset = 0) => {
      if (usesNativeStage()) {
        track.style.transform = '';
        if (offset === 0) {
          const top = getNativeStageScrollTop(activeIndex);
          if (Math.abs(viewport.scrollTop - top) > 1) {
            viewport.scrollTo({
              top,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
        return;
      }
      if (usesHorizontalCarousel()) {
        track.style.transform = `translate3d(${-activeIndex * viewport.clientWidth + offset}px, 0, 0)`;
        return;
      }
      track.style.transform = `translate3d(0, ${-activeIndex * viewport.clientHeight + offset}px, 0)`;
    };

    const updateMobileDragPosition = () => {
      mobileDragFrame = 0;
      updateTrackPosition(swipeOffset);
    };

    const resetCatalogScroll = () => {
      if (hasCampaign()) return;
      if (pageScroller && pageScroller.scrollTop !== 0) {
        pageScroller.scrollTo({ top: 0, behavior: 'auto' });
      }
    };

    const setFooterOpen = (open) => {
      /* A single-product stage never hands off to the document footer. The
         product viewport retains its own scrolling; grid mode keeps normal
         page scrolling on every screen size. */
      if (open && isSingleLayout && !mobileGridActive) open = false;

      const wasOpen = footerOpen;
      footerOpen = open;
      carousel.classList.toggle('product-carousel--footer-open', open);
      if (open && pageScroller) {
        window.requestAnimationFrame(() => {
          pageScroller.scrollTo({
            top: pageScroller.scrollHeight,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        });
      } else {
        resetCatalogScroll();
        if (wasOpen) {
          stageResumeLockedUntil = Date.now() + (window.innerWidth < 750 ? 420 : 620);
        }
      }
    };

    const navigateStage = (direction) => {
      if (!usesStageCarousel()) return;

      if (!footerOpen && Date.now() < stageResumeLockedUntil) return;

      if (footerOpen) {
        if (direction < 0) setFooterOpen(false);
        return;
      }

      if (direction > 0 && activeIndex === productSlides.length - 1) {
        const previousIndex = activeIndex;
        pagination?.loadNext?.().then(() => {
          if (!signal.aborted && activeIndex === previousIndex && usesStageCarousel()) showProduct(previousIndex + 1);
        });
        return;
      }

      if (direction < 0 && activeIndex === 0) return;
      showProduct(activeIndex + direction);
    };

    const warmProductImage = (index) => {
      const image = productSlides[index]?.querySelector('.product-carousel__image');
      if (!image) return;

      image.loading = 'eager';
      image.fetchPriority = 'high';
    };

    const showProduct = (index) => {
      if (!usesStageCarousel()) return;

      const nextIndex = Math.max(0, Math.min(index, productSlides.length - 1));

      if (nextIndex === activeIndex) return;

      isTransitioning = true;
      resetCatalogScroll();
      warmProductImage(nextIndex);
      activeIndex = nextIndex;
      warmProductImage(activeIndex - 1);
      warmProductImage(activeIndex + 1);
      syncLastStageProduct();
      /* Keep the last stage from opening the footer until its latest movement
         settles, while allowing a new swipe to retarget the track instantly. */
      footerUnlockAt = activeIndex === productSlides.length - 1
        ? Date.now() + (window.innerWidth < 750 ? 340 : 900)
        : 0;
      productSlides[activeIndex].classList.add('is-revealed');
      updateTrackPosition();

      productSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      syncStageMediaArrows();
      syncProductCounter();
      syncSwipeHint();

      window.clearTimeout(stageTransitionTimer);
      stageTransitionTimer = window.setTimeout(() => {
        isTransitioning = false;
        armDesktopLastStageHandoff();
      }, window.innerWidth < 750 ? 300 : 460);
    };

    let nativeStageScrollFrame = 0;
    const syncNativeStage = () => {
      nativeStageScrollFrame = 0;
      if (!usesNativeStage() || !viewport.clientHeight) return;

      const viewportCenter = viewport.scrollTop + (viewport.clientHeight / 2);
      let nextIndex = activeIndex;
      let closestDistance = Number.POSITIVE_INFINITY;

      productSlides.forEach((slide, slideIndex) => {
        const slideCenter = slide.offsetTop + (slide.offsetHeight / 2);
        const distance = Math.abs(slideCenter - viewportCenter);
        if (distance >= closestDistance) return;

        closestDistance = distance;
        nextIndex = slideIndex;
      });
      if (nextIndex === activeIndex) return;

      activeIndex = nextIndex;
      productSlides[activeIndex].classList.add('is-revealed');
      productSlides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      syncLastStageProduct();
      syncStageMediaArrows();
      syncProductCounter();
      syncSwipeHint();
    };

    const applyLayout = (single, savePreference = true) => {
      const wasSingleLayout = isSingleLayout;
      isSingleLayout = single;
      document.documentElement.classList.toggle('minimal-catalog-grid-initial', !single && window.innerWidth >= 750);
      carousel.classList.toggle('product-carousel--columns-1', single);
      carousel.classList.toggle(`product-carousel--columns-${gridColumns}`, !single);
      activeIndex = single ? gridFocusIndex : 0;
      isTransitioning = false;
      window.clearTimeout(stageTransitionTimer);
      footerUnlockAt = 0;
      setFooterOpen(false);
      resetCatalogScroll();
      syncLastStageProduct();
      if (single) {
        if (!wasSingleLayout) track.style.transition = 'none';
        updateTrackPosition();
        if (!wasSingleLayout) {
          track.getBoundingClientRect();
          track.style.transition = '';
        }
        productSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
        });
      } else {
        /* A product's size picker is designed for the one-product stage. In a
           four-card catalogue it stretches the entire grid row, so close any
           open picker before returning to the compact grid. */
        productSlides.forEach((slide) => {
          /* A product that was not yet visited in the one-product stage still
             has its vertical reveal state. A grid must never make those cards
             rise in from below when it opens. */
          slide.classList.add('is-revealed');
          slide.classList.remove('is-expanded');
          slide.querySelector('[data-product-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        /* Freeze the stage track while it becomes a grid. Without this, a
           product viewed lower in the stage first animates back through every
           preceding product before its grid card can be positioned. */
        if (wasSingleLayout) track.style.transition = 'none';
        track.style.transform = '';
        if (wasSingleLayout) {
          track.getBoundingClientRect();
          track.style.transition = '';
        }
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncProductCounter();
      syncSwipeHint();
      if (savePreference) writeMinimalCatalogLayout('desktop', single ? 'single' : 'grid');
    };

    const alignGridToFocusedProduct = (index) => {
      /* The first row is already in the ideal position. For subsequent rows,
         put the selected card beneath the header before the new View
         Transition snapshot is taken. This uses its actual layout position,
         not a hard-coded product count, so any collection length works. */
      if (!pageScroller || index < gridColumns) return;

      const focusedSlide = productSlides[index];
      if (!focusedSlide) return;

      const header = document.querySelector('.minimal-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const targetTop = Math.max(headerBottom + 24, 160);
      const currentTop = focusedSlide.getBoundingClientRect().top;
      const nextScrollTop = Math.max(0, pageScroller.scrollTop + currentTop - targetTop);

      pageScroller.scrollTop = nextScrollTop;
    };

    const transitionFocusedProductLayout = (single, focusedSlide, focusedIndex, savePreference) => {
      gridFocusIndex = focusedIndex;
      applyLayout(single, savePreference);
      if (!single) alignGridToFocusedProduct(focusedIndex);
      carousel.animate(
        [
          { opacity: .72 },
          { opacity: 1 }
        ],
        {
          duration: 360,
          easing: 'cubic-bezier(.16, 1, .3, 1)',
          fill: 'both'
        }
      );
    };

    const setLayout = (single, savePreference = true) => {
      if (!canUseDesktopGrid || single === isSingleLayout) return;

      const canAnimateLayout = savePreference
        && window.innerWidth >= 990
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches === false;

      if (canAnimateLayout) {
        const focusedIndex = single ? gridFocusIndex : activeIndex;
        const focusedSlide = productSlides[focusedIndex];

        if (!focusedSlide) {
          applyLayout(single, savePreference);
          return;
        }

        transitionFocusedProductLayout(single, focusedSlide, focusedIndex, savePreference);
        return;
      }

      applyLayout(single, savePreference);
    };

    const setMobileGrid = (active, savePreference = true) => {
      active = active && canUseMobileGrid;
      mobileGridActive = active;
      carousel.classList.toggle('product-carousel--mobile-grid-active', active);
      const mobileColumns = active ? configuredMobileGridColumns : 1;
      carousel.style.setProperty('--product-carousel-mobile-columns', String(mobileColumns));
      carousel.style.setProperty('--product-carousel-mobile-media-height', mobileColumns === 2 ? '42vw' : '76vw');

      if (active) {
        track.style.transform = '';
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      } else {
        activeIndex = 0;
        updateTrackPosition();
        productSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
        });
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncLastStageProduct();
      if (savePreference) writeMinimalCatalogLayout('mobile', active ? 'grid' : 'single');
    };

    if (window.innerWidth < 750) {
      setMobileGrid(initialCatalogLayout === 'grid', false);
    } else if (window.innerWidth >= 750) {
      setLayout(initialCatalogLayout !== 'grid', false);
    }

    /* Bind the action to the freshly rendered carousel itself. Shopify replaces
       this section's DOM after every editor setting change; dispatching to the
       current DOM node avoids keeping a stale closure from the prior render. */
    const toggleCatalogLayout = () => {
      if (window.innerWidth < 750) {
        setMobileGrid(!mobileGridActive);
        return;
      }

      if (canUseDesktopGrid && window.innerWidth >= 750) {
        setLayout(!isSingleLayout);
      }
    };

    /* The header can survive a Shopify section replacement while this carousel
       is recreated. Expose one tiny current-DOM controller, so the visible
       grid button never keeps a listener bound to an obsolete section node. */
    carousel.minimalToggleCatalogLayout = toggleCatalogLayout;
    window.minimalCatalogToggleLayout = () => {
      document.querySelector('[data-product-carousel]')?.minimalToggleCatalogLayout?.();
    };
    carousel.addEventListener('minimal-layout-toggle', toggleCatalogLayout);

    notifyLayoutState();
    window.requestAnimationFrame(notifyLayoutState);
    syncStageMediaArrows();
    syncProductCounter();
    syncSwipeHint();
    syncLastStageProduct();
    warmProductImage(activeIndex + 1);
    stageMediaPrevious?.addEventListener('click', () => {
      productSlides[activeIndex]?.querySelector('[data-product-media-carousel]')?.dispatchEvent(new Event('minimal:previous-image'));
    });

    stageMediaNext?.addEventListener('click', () => {
      productSlides[activeIndex]?.querySelector('[data-product-media-carousel]')?.dispatchEvent(new Event('minimal:next-image'));
    });

    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { root: viewport, rootMargin: '0px 0px -12% 0px', threshold: .16 });

      productSlides.forEach((slide) => revealObserver.observe(slide));
    } else {
      productSlides.forEach((slide) => slide.classList.add('is-revealed'));
    }

    if (previewThemeId) {
      carousel.querySelectorAll('[data-product-page-link]').forEach((link) => {
        const productUrl = new URL(link.href, window.location.origin);
        productUrl.searchParams.set('preview_theme_id', previewThemeId);
        link.href = productUrl.toString();
      });
    }

    const handleCarouselWheel = (event) => {
      if (window.innerWidth < 750) return;
      if (!usesStageCarousel()) return;

      /* In the desktop vertical stage, keep the browser's own smooth scroll
         and snap. Only the extra wheel movement after the final card hands
         control to the page footer. */
      if (usesNativeStage()) {
        const atNativeStageEnd = isLastStageProduct()
          && viewport.scrollTop >= viewport.scrollHeight - viewport.clientHeight - 2;
        if (atNativeStageEnd && event.deltaY > 8) {
          event.preventDefault();
          setFooterOpen(true);
        }
        return;
      }

      const isHorizontal = usesHorizontalCarousel();
      const primaryDelta = isHorizontal ? event.deltaX : event.deltaY;
      const secondaryDelta = isHorizontal ? event.deltaY : event.deltaX;
      if (Math.abs(primaryDelta) <= Math.abs(secondaryDelta) || Math.abs(primaryDelta) < 8) return;

      const direction = primaryDelta > 0 ? 1 : -1;

      /* A trackpad keeps emitting momentum after the gesture that selects the
         last product. Hold only that tail so the last stage can settle before
         the following, separate gesture continues into the newsletter. */
      if (isLastStageProduct() && !desktopLastStageReady) {
        event.preventDefault();
        armDesktopLastStageHandoff();
        return;
      }

      if (isLastStageProduct()) {
        if (direction > 0) return;
        if (pageScroller && pageScroller.scrollTop > 0) return;
      }

      /* Once the footer is open, it belongs to the normal page scroll. Do not
         intercept its wheel events with the product carousel. */
      if (footerOpen) {
        if (pageScroller && pageScroller.scrollTop > 0) return;
        if (direction < 0) {
          event.preventDefault();
          setFooterOpen(false);
        }
        return;
      }

      if (Date.now() < stageResumeLockedUntil) {
        event.preventDefault();
        return;
      }

      /* The catalog is a fixed slide stage. Never hand trackpad momentum to
         the surrounding scroller: that is what intermittently left the last
         product halfway off-screen with the footer underneath it. */
      event.preventDefault();

      /* A single trackpad gesture can emit many wheel events. Keep it to one
         product, but accept a genuine opposite-direction swipe immediately. */
      window.clearTimeout(wheelGestureReleaseTimer);
      wheelGestureReleaseTimer = window.setTimeout(() => {
        wheelGestureActive = false;
        wheelGestureDirection = 0;
      }, 75);

      if (wheelGestureActive && wheelGestureDirection === direction) return;
      wheelGestureActive = true;
      wheelGestureDirection = direction;

      if (pageScroller && pageScroller.scrollTop !== 0) {
        resetCatalogScroll();
        return;
      }

      const indexBeforeNavigation = activeIndex;
      const footerWasOpen = footerOpen;
      navigateStage(direction);

      if (activeIndex === indexBeforeNavigation && footerOpen === footerWasOpen) return;
    };

    (pageScroller || viewport).addEventListener('wheel', handleCarouselWheel, { passive: false, signal });

    viewport.addEventListener('scroll', () => {
      if (!usesNativeStage() || nativeStageScrollFrame) return;
      nativeStageScrollFrame = window.requestAnimationFrame(syncNativeStage);
    }, { passive: true });

    /* Covers scrollbar dragging, keyboard scrolling and any momentum event
       that reaches the container after a slide transition. */
    if (pageScroller) {
      pageScroller.addEventListener('scroll', () => {
        if (!footerOpen && usesStageCarousel() && pageScroller.scrollTop !== 0 && !isLastStageProduct()) {
          resetCatalogScroll();
        }
      }, { passive: true, signal });
    }

    viewport.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      swipeOffset = 0;
      if (event.target.closest('[data-product-media-carousel]')) return;
      if (usesNativeStage()) return;
      if (!usesStageCarousel() || (usesVerticalCarousel() && event.pointerType === 'mouse')) return;
      if (isMobileLastProduct()) return;
      carousel.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!usesStageCarousel() || !carousel.classList.contains('is-dragging')) return;

      const distance = usesHorizontalCarousel() ? event.clientX - startX : event.clientY - startY;
      const atStart = activeIndex === 0 && distance > 0;
      const atEnd = activeIndex === productSlides.length - 1 && distance < 0;
      swipeOffset = Math.max(-150, Math.min(150, distance * (atStart || atEnd ? .18 : .62)));
      if (window.innerWidth >= 750) {
        updateTrackPosition(swipeOffset);
        return;
      }

      if (!mobileDragFrame) mobileDragFrame = window.requestAnimationFrame(updateMobileDragPosition);
    });

    viewport.addEventListener('pointerup', (event) => {
      if (!usesStageCarousel() || !carousel.classList.contains('is-dragging')) return;

      const distance = usesHorizontalCarousel() ? event.clientX - startX : event.clientY - startY;
      carousel.classList.remove('is-dragging');
      swipeOffset = 0;
      if (mobileDragFrame) {
        window.cancelAnimationFrame(mobileDragFrame);
        mobileDragFrame = 0;
      }

      /* Touch navigation is handled solely by touchend below. Handling the
         pointer event too made a genuine second upward swipe look like a
         duplicate of the first one. */
      if (event.pointerType === 'touch') {
        updateTrackPosition();
        return;
      }

      if (Math.abs(distance) <= 45) {
        updateTrackPosition();
        return;
      }
      if (isMobileLastProduct() && distance < 0) return;
      navigateStage(distance < 0 ? 1 : -1);
    });

    viewport.addEventListener('pointercancel', () => {
      carousel.classList.remove('is-dragging');
      swipeOffset = 0;
      if (mobileDragFrame) {
        window.cancelAnimationFrame(mobileDragFrame);
        mobileDragFrame = 0;
      }
      if (!usesNativeStage()) updateTrackPosition();
    });

    /* Photo galleries own horizontal gestures. When a finger moves vertically
       over a garment, pass that gesture back to the one-product stage instead
       of leaving the user on a dead area of the slide. */
    carousel.addEventListener('minimal:stage-swipe', (event) => {
      if (usesNativeStage()) return;
      if (window.innerWidth >= 750 || !usesVerticalCarousel()) return;
      if (isMobileLastProduct() && event.detail.direction > 0) return;
      navigateStage(event.detail.direction);
    });

    /* Some mobile browsers deliver touch events more reliably than pointer
       events inside a fixed-height, internally scrolling storefront. Keep a
       small fallback so swipe-up/down always advances the product carousel. */
    viewport.addEventListener('touchstart', (event) => {
      /* On the final product, keep a downward swipe available everywhere to
         return to the previous card. An upward swipe still belongs to normal
         page scrolling below the stage. */
      stageTouchEnabled = !event.target.closest('[data-product-media-carousel]');
      startX = event.touches[0]?.clientX || 0;
      startY = event.touches[0]?.clientY || 0;
      if (usesNativeStage()) return;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      if (usesNativeStage()) {
        /* On phones the one-product catalogue is a closed stage. Letting the
           final card hand off to the footer mixes two scroll containers and
           makes the gallery motion unstable, so the footer stays for grid and
           normal page layouts instead. */
        if (window.innerWidth < 750) return;

        const endY = event.changedTouches[0]?.clientY || startY;
        const atStageEnd = activeIndex === productSlides.length - 1
          && viewport.scrollTop >= viewport.scrollHeight - viewport.clientHeight - 2;

        /* One intentional extra upward swipe after the last product hands
           control back to the normal page. */
        if (atStageEnd && endY - startY < -45) setFooterOpen(true);
        return;
      }
      if (!usesStageCarousel() || !stageTouchEnabled) return;

      const endPoint = event.changedTouches[0];
      const distance = usesHorizontalCarousel()
        ? (endPoint?.clientX || startX) - startX
        : (endPoint?.clientY || startY) - startY;

      if (Math.abs(distance) <= 45) return;
      if (isMobileLastProduct() && distance < 0) return;
      navigateStage(distance < 0 ? 1 : -1);
    }, { passive: true });

    window.addEventListener('resize', () => {
      const isMobile = window.innerWidth < 750;
      if (isMobile !== wasMobile) {
        const keepSingle = wasMobile ? !mobileGridActive : isSingleLayout;
        if (isMobile) {
          setMobileGrid(!keepSingle, false);
        } else {
          setMobileGrid(false, false);
          setLayout(keepSingle, false);
        }
      }
      wasMobile = isMobile;
      if (window.innerWidth >= 750 && mobileGridActive) {
        setMobileGrid(false);
      }

      if (usesStageCarousel()) {
        if (usesNativeStage() && window.innerWidth < 750) {
          /* iOS resizes while its browser controls move. Native scroll snap
             already tracks that geometry; forcing scrollTop here was what
             made the final image jump away from its card. */
          track.style.transform = '';
        } else {
          updateTrackPosition();
        }
      } else {
        track.style.transform = '';
        productSlides.forEach((slide) => slide.setAttribute('aria-hidden', 'false'));
      }

      notifyLayoutState();
      syncStageMediaArrows();
      syncLastStageProduct();
    }, { signal });

    /* On a phone, the whole open area of a product card should behave as its
       product link. Explicit controls keep their own actions. */
    const initializeProductCards = (slides) => {
      slides.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          if (window.innerWidth >= 750 || !usesVerticalCarousel() || event.defaultPrevented) return;
          if (event.target.closest('a, button, input, select, textarea, label')) return;

          const productLink = slide.querySelector('a[data-product-page-link].is-active');
          if (productLink?.href) openProductPageFromCard(productLink.href);
        }, { signal });
      });

      slides.flatMap((slide) => Array.from(slide.querySelectorAll('[data-product-toggle]'))).forEach((toggle) => {
        const slide = toggle.closest('[data-carousel-slide]');
        const sizeOptions = Array.from(slide.querySelectorAll('[data-variant-option]'));

        toggle.addEventListener('click', (event) => {
          event.stopPropagation();

          /* Grid cards keep their compact height. Their plus sign opens the
             product page, where options are available, instead of expanding a
             single card and leaving a blank row underneath its neighbours. */
          if (!isSingleLayout && window.innerWidth >= 750) {
            const productLink = slide.querySelector('[data-product-page-link]');
            if (productLink?.href) openProductPageFromCard(productLink.href);
            return;
          }

          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          slide.classList.toggle('is-expanded', !isExpanded);
        });

        sizeOptions.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.stopPropagation();
            sizeOptions.forEach((sizeOption) => {
              const isSelected = sizeOption === option;
              sizeOption.classList.toggle('is-selected', isSelected);
              sizeOption.setAttribute('aria-pressed', String(isSelected));
            });

            const purchasePrice = slide.querySelector('[data-purchase-price]');
            const currentPrice = purchasePrice?.querySelector('[data-purchase-current-price]');
            const comparePrice = purchasePrice?.querySelector('[data-purchase-compare-price]');
            const isOnSale = option.dataset.variantOnSale === 'true';

            if (currentPrice) currentPrice.textContent = option.dataset.variantPrice;
            if (comparePrice) {
              comparePrice.hidden = !isOnSale;
              comparePrice.textContent = isOnSale ? option.dataset.variantComparePrice : '';
            }
            purchasePrice?.classList.toggle('product-carousel__purchase-price--sale', isOnSale);
          });
        });
      });

      slides.flatMap((slide) => Array.from(slide.querySelectorAll('[data-product-close]'))).forEach((close) => {
        close.addEventListener('click', (event) => {
          event.stopPropagation();
          const slide = close.closest('[data-carousel-slide]');
          const toggle = slide.querySelector('[data-product-toggle]');

          slide.classList.remove('is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });

      slides.flatMap((slide) => Array.from(slide.querySelectorAll('[data-add-to-cart]'))).forEach((addToCart) => {
        addToCart.addEventListener('click', async (event) => {
          event.stopPropagation();
          const slide = addToCart.closest('[data-carousel-slide]');
          const selectedVariant = slide.querySelector('[data-variant-option].is-selected:not(:disabled)');

          if (!selectedVariant) return;

          const defaultLabel = addToCart.dataset.addToCartLabel;
          addToCart.disabled = true;

          try {
            const cartRoot = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${cartRoot}cart/add.js`, {
              body: JSON.stringify({ id: Number(selectedVariant.dataset.variantId), quantity: 1 }),
              headers: { 'Content-Type': 'application/json' },
              method: 'POST'
            });

            if (!response.ok) throw new Error('Unable to add item');

            window.dispatchEvent(new CustomEvent('minimal:cart-updated', { detail: { added: true, trigger: addToCart } }));
            addToCart.textContent = addToCart.dataset.addedLabel;
            window.setTimeout(() => {
              addToCart.textContent = defaultLabel;
              addToCart.disabled = false;
            }, 600);
          } catch (error) {
            addToCart.disabled = false;
          }
        });
      });
    };
    initializeProductCards(productSlides);

    carousel.addEventListener('minimal:catalog-appended', (event) => {
      const slides = event.detail.slides;
      productSlides.push(...slides);
      initializeProductCards(slides);
      slides.forEach((slide) => {
        slide.setAttribute('aria-hidden', String(usesStageCarousel() && slide !== productSlides[activeIndex]));
        if (!usesStageCarousel()) slide.classList.add('is-revealed');
        revealObserver?.observe(slide);
        if (previewThemeId) {
          slide.querySelectorAll('[data-product-page-link]').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('preview_theme_id', previewThemeId);
            link.href = url.toString();
          });
        }
      });
      if (previewThemeId) {
        event.detail.mobileSlides.forEach((slide) => {
          slide.querySelectorAll('[data-product-page-link]').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('preview_theme_id', previewThemeId);
            link.href = url.toString();
          });
        });
      }
      initializeCatalog(carousel);
      syncLastStageProduct();
      syncProductCounter();
    }, { signal });
    carousel.minimalGetCatalogState = () => ({
      layout: window.innerWidth < 750 ? (mobileGridActive ? 'grid' : 'single') : (isSingleLayout ? 'single' : 'grid'),
      activeIndex,
      productId: productSlides[activeIndex]?.dataset.catalogProductId,
      loadedCount: productSlides.length
    });
    carousel.minimalRestoreCatalogState = (state) => {
      const single = state.layout === 'single';
      if (window.innerWidth < 750) setMobileGrid(!single, false);
      else applyLayout(single, false);
      const found = productSlides.findIndex((slide) => slide.dataset.catalogProductId === String(state.productId));
      activeIndex = Math.max(0, Math.min(productSlides.length - 1, found >= 0 ? found : Number(state.activeIndex) || 0));
      gridFocusIndex = activeIndex;
      if (usesStageCarousel()) updateTrackPosition();
      else track.style.transform = '';
      if (usesNativeStage()) viewport.scrollTo({ top: getNativeStageScrollTop(activeIndex), behavior: 'instant' });
      productSlides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(usesStageCarousel() && index !== activeIndex)));
      syncLastStageProduct();
      syncStageMediaArrows();
      syncProductCounter();
      syncSwipeHint();
    };
    carousel.dataset.catalogReady = 'true';
    syncProductCounter();
    carousel.dispatchEvent(new CustomEvent('minimal:catalog-ready', { bubbles: true }));

    catalogCleanups.set(carousel, () => {
      controller.abort();
      revealObserver?.disconnect();
      window.clearTimeout(stageTransitionTimer);
      window.clearTimeout(wheelGestureReleaseTimer);
      window.clearTimeout(desktopLastStageUnlockTimer);
      window.cancelAnimationFrame(mobileDragFrame);
      window.cancelAnimationFrame(nativeStageScrollFrame);
      delete carousel.minimalToggleCatalogLayout;
      delete carousel.minimalGetCatalogState;
      delete carousel.minimalRestoreCatalogState;
      delete carousel.dataset.catalogReady;
    });
  });

  /* A multi-product catalogue is ordinary page content, not a carousel. On
     phones the header grid icon can still switch it between one and two cards
     per row without attaching any swipe or viewport-locking behaviour. */
  root.querySelectorAll('.product-carousel--static-grid').forEach((carousel) => {
    if (carousel.hasAttribute('data-v3-home-grid')) {
      const rowTrack = carousel.querySelector('[data-v3-row-track]');
      carousel.dataset.catalogReady = 'true';
      carousel.minimalToggleCatalogLayout = () => {};
      carousel.minimalGetCatalogState = () => ({ layout: rowTrack ? 'row' : 'grid', rowScroll: rowTrack?.scrollLeft || 0, activeIndex: 0, productId: carousel.querySelector('[data-v3-grid-card]')?.dataset.catalogProductId, loadedCount: carousel.querySelectorAll('[data-v3-grid-card]').length });
      carousel.minimalRestoreCatalogState = (state) => { if (rowTrack) rowTrack.scrollTo({ left: Number(state.rowScroll) || 0, behavior: 'instant' }); };
      publishMinimalCatalogLayoutState({ available: false, single: false });
      if (!catalogCleanups.has(carousel)) {
        const controller = new AbortController();
        const rowCleanup = rowTrack ? initializeV3ProductRow(carousel, rowTrack, controller.signal) : () => {};
        carousel.addEventListener('minimal:catalog-appended', () => initializeCatalog(carousel), { signal: controller.signal });
        catalogCleanups.set(carousel, () => { controller.abort(); rowCleanup(); delete carousel.dataset.catalogReady; delete carousel.minimalToggleCatalogLayout; delete carousel.minimalGetCatalogState; delete carousel.minimalRestoreCatalogState; });
      }
      carousel.dispatchEvent(new CustomEvent('minimal:catalog-ready', { bubbles: true }));
      return;
    }
    let mobileColumns = Number(carousel.style.getPropertyValue('--product-carousel-mobile-columns')) || 1;
    const isThemeEditor = Boolean(window.Shopify?.designMode);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');

    const isMobile = () => window.innerWidth < 750;

    const notifyMobileGridState = () => {
      publishMinimalCatalogLayoutState({
        available: isMobile() || isThemeEditor,
        single: isMobile() ? mobileColumns === 1 : carousel.classList.contains('product-carousel--editor-single-preview')
      });
    };

    const setMobileColumns = (columns, savePreference = true) => {
      mobileColumns = columns;
      carousel.style.setProperty('--product-carousel-mobile-columns', String(columns));
      carousel.style.setProperty('--product-carousel-mobile-media-height', columns === 2 ? '42vw' : '76vw');
      notifyMobileGridState();
      if (savePreference) writeMinimalCatalogLayout('mobile', columns === 2 ? 'grid' : 'single');
    };

    /* A fixed catalogue grid follows its Theme editor settings on every
       visit. Do not let an old local browser preference override it. */

    /* Static grids do not use the animated carousel initialiser above, so
       preserve the draft theme when a customer opens a product from a grid. */
    if (previewThemeId) {
      carousel.querySelectorAll('[data-product-page-link]').forEach((link) => {
        const productUrl = new URL(link.href, window.location.origin);
        productUrl.searchParams.set('preview_theme_id', previewThemeId);
        link.href = productUrl.toString();
      });
    }

    const toggleStaticGridLayout = () => {
      if (isMobile()) {
        setMobileColumns(mobileColumns === 1 ? 2 : 1);
        return;
      }

      if (isThemeEditor) {
        const showingSinglePreview = carousel.classList.toggle('product-carousel--editor-single-preview');
        publishMinimalCatalogLayoutState({ available: true, single: showingSinglePreview });
      }
    };

    /* In the theme editor Shopify intentionally uses a static carousel copy.
       Give that copy the same direct controller as the live carousel, so the
       header button still works in the editor's mobile preview. */
    carousel.minimalToggleCatalogLayout = toggleStaticGridLayout;
    window.minimalCatalogToggleLayout = () => {
      document.querySelector('.product-carousel')?.minimalToggleCatalogLayout?.();
    };
    carousel.addEventListener('minimal-layout-toggle', toggleStaticGridLayout);

    window.addEventListener('resize', notifyMobileGridState);
    notifyMobileGridState();
    window.requestAnimationFrame(notifyMobileGridState);
  });

  root.querySelectorAll('[data-product-media-carousel]').forEach((mediaCarousel) => {
    const slides = Array.from(mediaCarousel.querySelectorAll('[data-media-slide]'));
    const mediaTrack = mediaCarousel.querySelector('[data-media-track]');
    if (!mediaTrack || !slides.length || mediaTrack.dataset.galleryReady) return;
    mediaTrack.dataset.galleryReady = 'true';

    const previous = mediaCarousel.querySelector('[data-media-previous]');
    const next = mediaCarousel.querySelector('[data-media-next]');
    const dots = Array.from(mediaCarousel.querySelectorAll('[data-media-dot]'));
    let activeIndex = 0;
    let scrollFrame = 0;
    let suppressGestureClick = false;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let mouseDragging = false;

    const syncState = () => {
      const activeDotIndex = dots.length
        ? Math.min(dots.length - 1, Math.floor(activeIndex * dots.length / slides.length))
        : -1;
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeDotIndex);
        dot.setAttribute('aria-current', String(index === activeDotIndex));
      });
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });
    };

    const showImage = (index, behavior = 'smooth') => {
      const target = Math.max(0, Math.min(index, slides.length - 1));
      // Hidden copies have no geometry until the visitor switches views.
      if (!mediaTrack.clientWidth) return;
      mediaTrack.scrollTo({
        left: slides[target].offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior
      });
    };

    mediaTrack.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        if (!mediaTrack.clientWidth) return;
        let nearest = 0;
        slides.forEach((slide, index) => {
          if (Math.abs(slide.offsetLeft - mediaTrack.scrollLeft)
            < Math.abs(slides[nearest].offsetLeft - mediaTrack.scrollLeft)) nearest = index;
        });
        activeIndex = nearest;
        syncState();
      });
    }, { passive: true });

    previous?.addEventListener('click', () => showImage(activeIndex - 1));
    next?.addEventListener('click', () => showImage(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => showImage(Number(dot.dataset.mediaDot))));
    mediaCarousel.addEventListener('minimal:previous-image', () => showImage(activeIndex - 1));
    mediaCarousel.addEventListener('minimal:next-image', () => showImage(activeIndex + 1));

    // Touch scrolling is entirely native. Only mouse dragging needs a
    // controller; keep it separate from the enclosing product navigation.
    mediaTrack.addEventListener('pointerdown', (event) => {
      suppressGestureClick = false;
      if (mediaCarousel.closest('.product-carousel--v3-home-row')) return;
      if (event.pointerType !== 'mouse' || event.button !== 0 || slides.length < 2) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScroll = mediaTrack.scrollLeft;
      mouseDragging = false;
      event.stopPropagation();
    });
    mediaTrack.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientX - startX;
      if (!mouseDragging && Math.abs(distance) > 8 && Math.abs(distance) > Math.abs(event.clientY - startY)) {
        mouseDragging = true;
        suppressGestureClick = true;
        mediaTrack.style.scrollSnapType = 'none';
        mediaTrack.setPointerCapture?.(event.pointerId);
      }
      if (!mouseDragging) return;
      event.preventDefault();
      event.stopPropagation();
      mediaTrack.scrollLeft = startScroll - distance;
    });
    const endMouseDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      const dragged = mouseDragging;
      pointerId = null;
      mouseDragging = false;
      if (mediaTrack.hasPointerCapture?.(event.pointerId)) mediaTrack.releasePointerCapture(event.pointerId);
      mediaTrack.style.removeProperty('scroll-snap-type');
      if (!dragged) return;
      event.stopPropagation();
      const distance = event.clientX - startX;
      const startIndex = Math.round(startScroll / mediaTrack.clientWidth);
      const target = Math.abs(distance) > Math.min(48, mediaTrack.clientWidth * .18)
        ? startIndex + (distance < 0 ? 1 : -1)
        : startIndex;
      showImage(target);
    };
    mediaTrack.addEventListener('pointerup', endMouseDrag);
    mediaTrack.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== pointerId) return;
      pointerId = null;
      mouseDragging = false;
      mediaTrack.style.removeProperty('scroll-snap-type');
      showImage(activeIndex);
    });
    mediaTrack.addEventListener('dragstart', (event) => event.preventDefault());

    mediaTrack.addEventListener('touchstart', (event) => {
      suppressGestureClick = false;
      startX = event.touches[0]?.clientX || 0;
      startY = event.touches[0]?.clientY || 0;
    }, { passive: true });
    mediaTrack.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (touch && (Math.abs(touch.clientX - startX) > 8 || Math.abs(touch.clientY - startY) > 8)) {
        suppressGestureClick = true;
      }
    }, { passive: true });

    mediaCarousel.addEventListener('click', (event) => {
      if (suppressGestureClick) {
        suppressGestureClick = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const productLink = event.target.closest('a[data-product-page-link]');
      if (!productLink) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openProductPageFromCard(productLink.href, productLink);
    });

    // Let the browser process horizontal trackpad scrolling, without the
    // enclosing catalogue converting it into a product/page navigation.
    mediaTrack.addEventListener('wheel', (event) => {
      if (slides.length > 1 && Math.abs(event.deltaX) > Math.abs(event.deltaY)) event.stopPropagation();
    }, { passive: true });

    let resizeObserver;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => showImage(activeIndex, 'instant'));
      resizeObserver.observe(mediaTrack);
    }
    galleryCleanups.set(mediaCarousel, () => {
      resizeObserver?.disconnect();
      window.cancelAnimationFrame(scrollFrame);
    });
    syncState();
  });
  };

  const cleanupCatalog = (root) => {
    [catalogCleanups, galleryCleanups].forEach((cleanups) => {
      cleanups.forEach((cleanup, element) => {
        if (root !== element && !root.contains(element)) return;
        cleanup();
        cleanups.delete(element);
      });
    });
  };
  initializeCatalog(document);
  document.addEventListener('shopify:section:load', (event) => initializeCatalog(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanupCatalog(event.target));

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-search-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v3-search')) {
    customElements.define('v3-search', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('[data-search-input]');
        this.initial = this.querySelector('[data-search-initial]');
        this.results = this.querySelector('[data-search-results]');
        this.status = this.querySelector('[data-search-status]');
        this.clear = this.querySelector('[data-search-clear]');
        this.all = this.querySelector('[data-search-all]');
        this.form = this.querySelector('form');
        this.cache = new Map();
        this.sequence = 0;
        const options = { signal: this.abort.signal };
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-v3-search-open]');
          if (!trigger || trigger.dataset.v3SearchOpen !== this.dataset.searchId || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.opener = trigger;
          this.oldOverflow = document.documentElement.style.overflowY;
          document.documentElement.style.overflowY = 'hidden';
          this.dialog.showModal();
          this.input.focus({ preventScroll: true });
          this.change();
        }, options);
        this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        window.addEventListener('pageshow', () => { if (this.dialog.open) this.dialog.close(); }, options);
        this.input.addEventListener('input', event => { if (!event.isComposing) this.change(); }, options);
        this.input.addEventListener('compositionend', () => this.change(), options);
        this.clear.addEventListener('click', () => { this.input.value = ''; this.change(); this.input.focus({ preventScroll: true }); }, options);
        this.form.addEventListener('submit', event => {
          const query = this.input.value.trim();
          if (!query) { event.preventDefault(); this.input.focus(); return; }
          this.input.value = query;
          this.preservePreview(this.form);
        }, options);
        this.dialog.addEventListener('keydown', event => {
          const links = Array.from(this.results.querySelectorAll('a'));
          if (this.results.hidden || !links.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          const index = links.indexOf(document.activeElement);
          if (event.target !== this.input && index < 0) return;
          event.preventDefault();
          if (event.key === 'ArrowUp' && index <= 0) this.input.focus();
          else links[Math.min(links.length - 1, Math.max(0, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
        }, options);
        this.preservePreview(this.form);
      }
      preservePreview(form) {
        const id = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (!id || form.querySelector('[name="preview_theme_id"]')) return;
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = id; form.append(input);
      }
      searchURL(query) {
        const url = new URL(this.form.action, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'last');
        const id = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (id) url.searchParams.set('preview_theme_id', id);
        return url;
      }
      change() {
        clearTimeout(this.timer);
        this.request?.abort();
        const sequence = ++this.sequence;
        const query = this.input.value.trim();
        this.clear.hidden = !query;
        this.initial.hidden = Boolean(query);
        this.results.hidden = true;
        this.results.replaceChildren();
        this.results.removeAttribute('aria-busy');
        this.status.textContent = '';
        this.all.hidden = !query;
        if (!query) return;
        this.all.href = this.searchURL(query).href;
        this.status.textContent = this.dataset.loading;
        this.timer = setTimeout(() => this.load(query, sequence), 220);
      }
      async load(query, sequence) {
        this.request = new AbortController();
        this.results.setAttribute('aria-busy', 'true');
        try {
          let html = this.cache.get(query);
          if (!html) {
            const url = new URL(this.dataset.suggestUrl, window.location.origin);
            url.searchParams.set('q', query);
            url.searchParams.set('resources[type]', 'product,collection');
            url.searchParams.set('resources[limit]', '8');
            url.searchParams.set('resources[limit_scope]', 'each');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            url.searchParams.set('section_id', 'v3-predictive-search');
            const id = new URL(window.location.href).searchParams.get('preview_theme_id');
            if (id) url.searchParams.set('preview_theme_id', id);
            const response = await fetch(url, { signal: this.request.signal, headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Search unavailable');
            html = await response.text();
          }
          if (sequence !== this.sequence || !this.dialog.open || query !== this.input.value.trim()) return;
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-response]');
          if (!content) throw new Error('Search response missing');
          if (this.cache.size >= 12) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query, html);
          const id = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (id) content.querySelectorAll('a[href]').forEach(link => { const url = new URL(link.getAttribute('href'), window.location.origin); if (url.origin === window.location.origin) { url.searchParams.set('preview_theme_id', id); link.href = url.href; } });
          this.results.replaceChildren(...content.childNodes);
          this.results.hidden = false;
          this.status.textContent = content.dataset.announcement || '';
        } catch (error) {
          if (error.name !== 'AbortError' && sequence === this.sequence && this.dialog.open) this.status.textContent = this.dataset.error;
        } finally {
          if (sequence === this.sequence) this.results.removeAttribute('aria-busy');
        }
      }
      restore() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.sequence++;
        this.results?.removeAttribute('aria-busy');
        if (this.oldOverflow !== undefined) document.documentElement.style.overflowY = this.oldOverflow;
        this.oldOverflow = undefined;
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restore();
        this.abort?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
